var map = {
	"./add.svg": 2021,
	"./arrow.svg": 600,
	"./back.svg": 412,
	"./change.svg": 6997,
	"./company.svg": 3734,
	"./copy.svg": 8838,
	"./delete.svg": 4928,
	"./department.svg": 295,
	"./file.svg": 3735,
	"./home.svg": 7123,
	"./list.svg": 9161,
	"./menu.svg": 8804,
	"./more.svg": 6482,
	"./next.svg": 214,
	"./pdf.svg": 8001,
	"./prev.svg": 2938,
	"./qiwei.svg": 4264,
	"./record.svg": 1214,
	"./right-arrow-black.svg": 9535,
	"./right-arrow-fill.svg": 8421,
	"./seal.svg": 4462,
	"./setting.svg": 2419,
	"./success.svg": 1530,
	"./take-photo.svg": 1435,
	"./tel.svg": 4580,
	"./turn-on.svg": 6262,
	"./upload.svg": 9538,
	"./weixin.svg": 3327,
	"./word.svg": 4541
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2922;